import React, { Component } from 'react';

import Configs from 'Configuration';
import FhtFetchUrl from 'Utils/FhtFetchUrl.jsx';

import {
  Box,
  Button,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';

import {
  DataGrid
} from '@material-ui/data-grid';

import SnackbarContentWrapper from 'components/SnackbarContentWrapper';

const columns = [
  {
    field: 'lastName',
    headerName: 'Last name',
    sortable: false,
    width: 180,
  },
  {
    field: 'firstName',
    headerName: 'First name',
    sortable: false,
    width: 180,
  },
  {
    field: 'mobileNumber',
    headerName: 'Mobile Number',
    sortable: false,
    width: 200,
  },
  {
    field: 'age',
    headerName: 'Age',
    type: 'number',
    sortable: false,
    width: 150,
  },
  {
    field: 'consentStatus',
    headerName: 'Consent Status',
    sortable: false,
    width: 200,
  },
];

class WebProjectConsentManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Data
      patientDataIsLoading: true,
      patientData: [],
      patientDataRowCount: 0,
      patientPageNumber: 0,
      patientPageSize: 20,
      patientSelectionModel: [],
      filterFirstname: '',
      filterSurname: '',
      // Snackbar
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarVariant: "info"
    };

    this.getPatientData();
  }

  render() {
    return (
      <Box maxWidth={1200} margin="auto">
        {this.renderSnackbar()}
        <Typography variant="h3" gutterBottom>Patient Consent Management</Typography>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom>Patients</Typography>
                <Typography variant="subtitle1" gutterBottom>
                  Update the SMS consent management for patients participating in the WEB program. Patients that are opted out will no longer receive SMS messages.
                  You can filter patients using the fields below.
                </Typography>
                <Box paddingBottom={2}>
                  <Grid container spacing={3}>
                    <Grid item sm={12} md={5}>
                      <TextField
                        id="filter-last-name"
                        label="Last Name"
                        value={this.state.filterSurname}
                        onChange={(event) => this.setState({filterSurname: event.target.value})}
                        fullWidth
                      />
                    </Grid>
                    <Grid item sm={12} md={5}>
                      <TextField
                        id="filter-first-name"
                        label="First Name"
                        value={this.state.filterFirstname}
                        onChange={(event) => this.setState({filterFirstname: event.target.value})}
                        fullWidth
                      />
                    </Grid>
                    <Grid item sm={12} md={2}>
                      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", width: '100%', height: '100%' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => this.getPatientData(0, this.state.patientPageSize)}
                        >
                          Search
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }} paddingBottom={2}>
                  <div style={{ height: 600, width: '100%' }}>
                    <DataGrid
                      loading={this.state.patientDataIsLoading}
                      rows={this.state.patientData}
                      rowCount={this.state.patientDataRowCount}
                      columns={columns}
                      pagination
                      paginationMode='server'
                      onPageChange={(page) => this.onPageChange(page)}
                      page={this.state.patientPageNumber}
                      pageSize={this.state.patientPageSize}
                      rowsPerPageOptions={[20]}
                      checkboxSelection
                      selectionModel={this.state.patientSelectionModel}
                      onSelectionModelChange={(model) => this.onSelectionModelChange(model)}
                      disableColumnFilter
                      disableColumnMenu
                    />
                  </div>
                </Box>
                <Grid container spacing={1} justifyContent="center">
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => this.setPatientData(this.state.patientSelectionModel, 3)}
                      disabled={this.state.patientSelectionModel.length === 0 || this.state.patientDataIsLoading}
                    >
                      Opt In Selected Patients
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => this.setPatientData(this.state.patientSelectionModel, 2)}
                      disabled={this.state.patientSelectionModel.length === 0 || this.state.patientDataIsLoading}
                    >
                      Opt Out Selected Patients
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    );
  }

  async onPageChange(page) {
    await this.getPatientDataPaginated(page, this.state.patientPageSize);
  }

  async getPatientData() {
    await this.getPatientDataPaginated(this.state.patientPageNumber, this.state.patientPageSize);
  }

  async getPatientDataPaginated(page, pageSize) {
    try {
      this.setState({
        patientData: [],
        patientPageNumber: page,
        patientPageSize: pageSize,
        patientSelectionModel: [],
        patientDataIsLoading: true,
      });

      // Get patients
      let patientsApiUrl = `${Configs.getPatientsSmsOptOutStatus}?page=${page}&pageSize=${pageSize}`;
      if (this.state.filterSurname)
        patientsApiUrl += `&filterSurname=${this.state.filterSurname}`;
      if (this.state.filterFirstname)
        patientsApiUrl += `&filterFirstname=${this.state.filterFirstname}`;

      const patientsApi = FhtFetchUrl(patientsApiUrl);
      const response = await patientsApi.get();

      const patientData = response.data.map(x => ({
        id: x.patientData.patientExtractId,
        firstName: x.patientData.patientExtractFirstname,
        lastName: x.patientData.patientExtractSurname,
        mobileNumber: x.patientData.patientExtractMobileNumber,
        age: x.patientData.patientExtractAge,
        consentStatus: x.optOutData.optOutListResponse === 2 ? 'Opted Out' : 'Opted In',
      }));

      const patientDataRowCount = response.totalRows;

      this.setState({
        patientData,
        patientDataRowCount,
        patientPageNumber: page,
        patientPageSize: pageSize,
        patientDataIsLoading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({ snackbarMessage: "Error getting patient opt-out status", snackbarVariant: "error", openSnackbar: true });
    }
  }

  async setPatientData(patientIds, status) {
    this.setState({
      patientData: [],
      patientSelectionModel: [],
      patientDataIsLoading: true
    });

    // Get patients
    const patientsApi = FhtFetchUrl(Configs.setPatientsSmsOptOutStatus);
    const patientsApiBody = {
      patientIds,
      patientSmsOptOutStatus: status
    };

    await patientsApi.post(patientsApiBody)
      .then(async () => {
        this.setState({ snackbarMessage: `Updated opt-out status for ${patientIds.length} patients`, snackbarVariant: "success", openSnackbar: true });
        await this.getPatientData();
      })
      .catch(async () => {
        this.setState({ snackbarMessage: "Error updating patient opt-out status", snackbarVariant: "error", openSnackbar: true });
        await this.getPatientData();
      });
  }

  onSelectionModelChange(model) {
    console.log(model);
    this.setState({ patientSelectionModel: model });
  }

  renderSnackbar() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={this.state.openSnackbar}
        autoHideDuration={4000}
        onClose={() => this.setState({ openSnackbar: false })}
      >
        <SnackbarContentWrapper
          onClose={() => this.setState({ openSnackbar: false })}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
        />
      </Snackbar>
    );
  }
}

export default WebProjectConsentManagement;
